import React, { useEffect } from "react";
import { Box, TextField, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import DocumentItem from "../../Components/Masters/DocumentItem";

function TicketDetails(props) {
  useEffect(() => {
    console.log(props.selectedData, props.selectedData?.model, "selectedData");
  }, [props]);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "420px",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setIsViewOpen(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "100%",
          p: 3,
          backgroundColor: "#fff",
          minHeight: "100vh",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Ticket Details
        </Typography>
        <Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Date
            </Typography>

            <p>
              {new Date(props.selectedData?.createdAt).toLocaleDateString(
                "en-GB",
                { day: "2-digit", month: "2-digit", year: "numeric" }
              ) ?? ""}
            </p>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Ticket ID
            </Typography>
            <p> {props.selectedData?.ticketNumber ?? ""}</p>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Title
            </Typography>
            <p> {props.selectedData?.title ?? ""}</p>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Raised For
            </Typography>
            <p> {props.selectedData?.raisedAgainst ?? ""}</p>
          </Box>
          {props?.selectedData?.raisedAgainst === "Internal Support" && (
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                Assigned To
              </Typography>
              <p> {props.selectedData?.assignedTo?.name ?? ""}</p>
            </Box>
          )}
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Description
            </Typography>
            <p> {props.selectedData?.description ?? ""}</p>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Escalation Level
            </Typography>
            <p> {props.selectedData?.escalationLevel ?? ""}</p>
          </Box>
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Status
        </Typography>
        <p>{props.selectedData?.status ?? "-"}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Resolution Time
        </Typography>
        <p>{props.selectedData?.timeElapsed ?? "-"}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Resolution Remark
        </Typography>
        <p>{props.selectedData?.resolvedRemark ?? "-"}</p>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {/* Render Images First */}
            {props.selectedData &&
              props.selectedData?.documents?.length > 0 && (
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {props.selectedData?.documents
                    .filter((url) =>
                      ["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`image-${index}`} url={url} />
                    ))}
                </Box>
              )}

            {/* Render Other Documents */}
            {/* {props.selectedData && props.selectedData?.documents.length > 0 && (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {props.selectedData?.documents
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  .map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            )} */}

            {props.selectedData?.documents?.length > 0 &&
            props.selectedData?.documents.some((url) => url.trim() !== "") ? (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {props.selectedData?.documents
                  .filter(
                    (url) =>
                      url.trim() !== "" &&
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  .map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            ) : (
              "-"
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.isViewOpen}
        onClose={() => props.setIsViewOpen(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default TicketDetails;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
